import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import axios from "axios";

import convertNumbThousand from "../../utils/convertNumbThousand";
import { currencyType, getCarrierLogo } from "../../utils/flightInfo";
import ButtonPrimary from "../Button/ButtonPrimary";
import NcImage from "../NcImage/NcImage";
import NcModal from "../NcModal/NcModal";
import API_URL from "../../redux2";
import Loading from "../Loading";
import {
  getBookingById,
  updateBooking,
  updateWallet,
} from "../../redux2/booking/bookingSlice";
import CorporateList from "./CorporateList";
import customTime from "../../utils/customTime";
import { convertToNumber } from "../../utils/convertToNumber";
import { getMyEnterprise } from "../../redux2/enterprise/enterpriseSlice";
import {
  DIRECT_PAYMENT,
  NON_DOCUMENT_HOLDER,
  ONE_WEEK_CREDIT,
  USER_ROLE_AGENT,
  USER_ROLE_ENTERPRISE,
  USER_ROLE_MEMBER,
  WALLET_MINIMUM_AMOUNT,
} from "../../common/constants";
import { getMyCompany } from "../../redux2/user/userSlice";
import PaymentMethodsList from "../PaymentMethods/PaymentMethodsList";
import { paymentMethods } from "../../utils/paymentMethods";
import { SSRStatus, SSRTypes } from "../../utils/SSR";
import KachaCreditOTP from "./KachaCreditOTP";
import { openModal } from "../../redux2/modal/modalSlice";
import {
  getLoanProduct,
  initiateLoanRequest,
  KachaLoanRequest,
  requestLoan,
} from "../../services/payment";
import PassengerPricing from "./components/PassengerPrice";
import { is24HoursBeforeDeparture } from "../../services/helper";

const CheckOutPage = ({ className = "" }) => {
  const [error, setError] = useState(null);
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("wallet");
  const [selectedCorporate, setSelectedCorporate] = useState(null);
  const [showCorporateList, setShowCorporateList] = useState(false);
  const [showSSR, setShowSSR] = useState(true);
  const [payment, setPayment] = useState(null);
  const [kachaInfo, setKachaInfo] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const query = new URLSearchParams(location.search);
  const adults = query.get("adults");
  const children = query.get("children");
  const infants = query.get("infants");
  const labors = query.get("labors");
  const passengerTypeState = query.get("passengerTypeState");

  const {
    airReservation,
    reservation,
    travelers,
    charges,
    serviceCharge,
    systemFee,
    retrievalPnr,
    airPrice,
    queryURL,
    currency,
    creditDue,
    rateDifference,
  } = location.state;

  const { booking, isLoading } = useSelector((state) => state.booking);
  const { company } = useSelector((state) => state.user);
  const { enterprise } = useSelector((state) => state.enterprise);
  const { user } = useSelector((state) => state.auth);

  const { id } = useParams();

  useEffect(() => {
    dispatch(getBookingById(id));
    dispatch(getMyCompany());
  }, [dispatch, id]);

  useEffect(() => {
    if (user?.role === USER_ROLE_ENTERPRISE) {
      dispatch(getMyEnterprise());
      setPaymentMethod("webirr_cbe");
    }

    if (
      company &&
      currencyType(currency) === "USD" &&
      company?.USDCreditLimit > totalPrice
    ) {
      setPaymentMethod("USDCredit");
    } else {
      setPaymentMethod("");
    }

    if (
      company &&
      company.wallet <
        (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
          priceToNumber(totalPrice()) &&
      currencyType(currency) === "USD"
      // passengerTypeState !== NON_DOCUMENT_HOLDER
    ) {
      setPaymentMethod("webirr_cbe");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user?.role, company]);

  // useEffect(() => {
  //   if (booking?.data?.paymentStatus === "paid") {
  //     toast.success("Booking Successful");

  //     navigate(`/pay-done/${id}?${queryURL}`, {
  //       state: {
  //         ticket: ticket,
  //         airReservation,
  //         travelers,
  //         charges,
  //         serviceCharge,
  //         airPrice,
  //         queryURL,
  //       },
  //     });
  //     return;
  //   }
  // }, [
  //   airReservation,
  //   booking?.data?.paymentStatus,
  //   id,
  //   navigate,
  //   ticket,
  //   travelers,
  //   charges,
  //   serviceCharge,
  //   airPrice,
  //   queryURL,
  // ]);

  const currentDate = new Date();

  const diffTime = Math.abs(
    new Date(currentDate) - new Date(creditDue?.createdAt)
  );
  let diffDate = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  const departureTime =
    airReservation?.AirSegment?.[0]?._attributes?.DepartureTime ||
    airReservation?.AirSegment?._attributes?.DepartureTime;

  const carrier =
    airReservation?.AirSegment?.[0]?._attributes?.Carrier ||
    airReservation?.AirSegment?._attributes?.Carrier;

  const isBefore24Hours = is24HoursBeforeDeparture(departureTime);

  const handleClick = async (otp) => {
    // e.preventDefault();

    if (
      company &&
      paymentMethod === "wallet" &&
      company.wallet <
        (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
          priceToNumber(totalPrice())
    ) {
      toast.error(
        `You can't use wallet for payment. You don't have enough balance. Please use other payment method.`
      );
      return;
    }

    if (!company && paymentMethod === "credit") {
      if (!selectedCorporate) {
        toast.error("Please select corporate");
        return;
      }
    }

    setLoading(true);
    getTicket(otp)
      .then((res) => {
        if (res.TicketFailureInfo) {
          console.log(res);
          setError(res?.TicketFailureInfo?._attributes?.Message);
          setLoading(false);
        } else {
          setLoading(false);
          toast.success("Booking Successful");

          navigate(`/pay-done/${id}?${queryURL}`, {
            state: {
              ticket: res,
              airReservation,
              travelers,
              charges,
              serviceCharge,
              airPrice,
              reservation,
              queryURL,
              currency,
              rateDifference,
            },
          });
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.message) {
          setError(err?.response?.data?.message);
        }
        setLoading(false);
      });
  };

  const handleKachaSubmit = async (otp) => {
    handleClick(otp);
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
      setError(null);
    }
  }, [error]);

  let issueAt = moment(currentDate).format("YYYY-MM-DDTHH:mm:ss");

  const getTicket = (otp) =>
    new Promise((resolve, reject) => {
      let data = {
        id,
        PNR: airReservation._attributes.LocatorCode,
        payment: paymentMethod || "wallet",
        otp: otp || null,
        reference: kachaInfo?.reference || null,
        corporateName: selectedCorporate || null,
        // serviceCharge: charges !== 0 ? charges : serviceCharge,
        // systemFee: systemFee,
        userId: user?._id,
        companyId: company?._id,
        issuedAt: issueAt,
      };

      axios
        .post(API_URL + "flight/ticket", data)
        .then((res) => {
          resolve(res.data?.AirTicketingRsp);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });

  const handleWithoutPayment = (e) => {
    e.preventDefault();

    const data = {
      id,
      PNR: airReservation._attributes.LocatorCode,
      RetrievalPnr: retrievalPnr,
      payment: "none",
      paymentStatus: "pending",
      status: "pending",
      serviceCharge: charges !== 0 ? charges : serviceCharge,
      systemFee: systemFee,
    };

    dispatch(updateBooking(data));
    // toast.success("Booking Success");
    navigate("/");
  };

  const initiatePayment = async () => {
    if (paymentMethod === "kacha") {
      let totalPrincipal =
        parseFloat(airPrice._attributes.TotalPrice?.toString().slice(3)) +
        parseFloat(charges || 0) +
        parseFloat(serviceCharge || 0);

      const kachaReq = {
        phone: company?.officeNumber,
        // principal: totalPrincipal.toString(),
        principal: "100",
        // phone: "251923130324",
        code: "80000030",
        pnr_number: airReservation._attributes.LocatorCode,
      };

      try {
        setLoading(true);
        const [data, product] = await Promise.all([
          requestLoan(kachaReq),
          getLoanProduct(kachaReq.phone),
        ]);

        if (data?.initiate) {
          const modalData = {
            kacha: data?.initiate,
            id: booking?._id,
            issueTicket: true,
            product,
          };
          let modalType = "Kacha";
          setKachaInfo(data.initiate);

          dispatch(openModal({ modalType, data: modalData }));
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }

      return;
    }
    const data = {
      pnr: airReservation._attributes.LocatorCode,
      paymentMethod,
    };

    await initiateLoanRequest(data, setLoading, setPayment);
  };

  const handleCorporateSubmit = (selectedCorporate) => {
    setShowCorporateList(false);
    setSelectedCorporate(selectedCorporate);
  };

  if (loading || isLoading) {
    return <Loading />;
  }

  function totalPrice() {
    const airPriceTotal = parseFloat(
      airPrice._attributes.TotalPrice?.toString().slice(3)
    );

    let result =
      rateDifference > 1
        ? (airPriceTotal * rateDifference).toFixed(2)
        : airPriceTotal;

    result =
      parseFloat(result) +
        charges +
        parseFloat(serviceCharge || 0) +
        booking?.commission || 0;

    return convertNumbThousand(result);
  }

  function priceToNumber(str) {
    let result = str?.toString().replace(/,/g, "");
    return +result;
  }

  let instructions = [];
  if (payment?.paymentInstructionsAll) {
    instructions = payment?.paymentInstructionsAll;
  } else {
    instructions = payment?.paymentInstructions;
  }
  // switch (paymentMethod) {

  //   case "cbeBirr":
  //     instructions = CBEBirr;
  //     break;
  //   case "cbe":
  //     instructions = CBE;
  //     break;
  //   case "awash":
  //     instructions = Awash;
  //     break;
  //   case "abyssinia":
  //     instructions = Abyssinia;
  //     break;
  //   default:
  //     instructions = [];
  // }

  function customDate(date) {
    let d = date?.split("T")?.[0];
    return moment(d).format("DD MMM YYYY");
  }

  const renderInstructions = () => {
    return (
      <div className="p-6 mt-2 sm:space-y-1 sm:p-6 xl:px-8 xl:py-1">
        <div className="flex flex-col tracking-wider">
          {instructions?.map((item, index) => (
            <div key={index}>
              <h1 className="text-xl font-semibold text-center underline">
                {item?.type}
              </h1>
              <div key={index} className="flex items-start">
                <div className="flex flex-col">
                  {item?.instructions?.map((instruction, i) => (
                    <span
                      className="text-sm font-semibold text-neutral-900"
                      key={i}
                    >
                      {instruction}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <div className="flex flex-col p-6 space-y-6 w-full shadow sm:rounded-2xl lg:border border-neutral-200 sm:space-y-1 sm:p-6 xl:px-8 xl:py-1">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-40">
            {/* <div className="overflow-hidden rounded-2xl aspect-w-4 aspect-h-3 sm:aspect-h-4"> */}
            <NcImage src={getCarrierLogo(carrier)} />
          </div>
          <div className="py-5 space-y-3 sm:px-5">
            <span className="text-lg font-semibold text-neutral-500">
              <h1>{carrier}</h1>
            </span>
            {airReservation?.AirSegment instanceof Array ? (
              airReservation?.AirSegment.map((segment, index) => (
                <div key={index}>
                  <span className="text-lg font-semibold text-neutral-500 line-clamp-1">
                    <h1>
                      {segment._attributes.Origin} -{" "}
                      {segment._attributes.Destination}
                    </h1>
                  </span>
                  <span className="block mt-1 text-base font-medium">
                    {customDate(segment._attributes.DepartureTime)} -
                    {customDate(segment._attributes.ArrivalTime)}
                  </span>
                  <span className="block mt-1 text-base font-medium">
                    {customTime(segment._attributes.DepartureTime)} -
                    {customTime(segment._attributes.ArrivalTime)}
                  </span>
                </div>
              ))
            ) : (
              <div>
                {/* <span className="text-lg font-semibold text-neutral-500">
                  <h1>{airReservation?.AirSegment.Carrier}</h1>
                </span> */}
                <span className="text-lg font-semibold text-neutral-500 line-clamp-1">
                  <h1>
                    {airReservation?.AirSegment?._attributes?.Origin} -{" "}
                    {airReservation?.AirSegment?._attributes?.Destination}
                  </h1>
                </span>
                <span className="block mt-1 text-base font-medium">
                  {customDate(
                    airReservation?.AirSegment?._attributes?.DepartureTime
                  )}{" "}
                  -
                  {customDate(
                    airReservation?.AirSegment?._attributes?.ArrivalTime
                  )}
                </span>
                <span className="block mt-1 text-base font-medium">
                  {customTime(
                    airReservation?.AirSegment?._attributes?.DepartureTime
                  )}{" "}
                  -
                  {customTime(
                    airReservation?.AirSegment?._attributes?.ArrivalTime
                  )}
                </span>
              </div>
            )}

            <div className="flex flex-row justify-between">
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {parseInt(adults)} Adult
              </span>
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {children > 0 && children + " Children"}
              </span>
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {infants > 0 && infants + " Infants"}
              </span>
            </div>

            <div className="w-10 border-b border-neutral-200 dark:border-neutral-700"></div>
            {/* <StartRating /> */}
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold">Price detail</h3>

          <div>
            <PassengerPricing
              label={+adults > 0 ? "Adults" : "Labors"}
              count={+adults > 0 ? adults : labors}
              priceIndex={0}
              AirPricing={airPrice}
              rateDifference={rateDifference}
            />
            <PassengerPricing
              label="Children"
              count={children}
              priceIndex={1}
              AirPricing={airPrice}
              rateDifference={rateDifference}
            />
            <PassengerPricing
              label="Infants"
              count={infants}
              priceIndex={children > 0 ? 2 : 1}
              AirPricing={airPrice}
              rateDifference={rateDifference}
            />
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            <span>
              {charges !== 0 ? charges : serviceCharge} {currencyType(currency)}
            </span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Agent Fee</span>
            <span>
              {booking?.commission || 0} {currencyType(currency)}
            </span>
          </div>

          {paymentMethod === "credit" && creditDue && (
            <div className="py-3 space-y-2 text-red-500 rounded-lg">
              <div className="flex justify-between">
                <span>Due Date</span>
                <span>
                  {/* add 7 days on creditDue */}
                  {moment(creditDue?.createdAt)
                    .add(7, "days")
                    .format("DD MMM YYYY")}
                </span>
              </div>
              <hr />
              <div className="flex justify-between">
                <span>Facilitation Fee at day one</span>
                <span>
                  {
                    +(
                      (booking?.flight?.price + booking?.serviceCharge) *
                      0.003
                    ).toFixed(2)
                  }{" "}
                </span>
              </div>

              <hr />

              <div className="flex justify-between">
                <span>Daily Fee After day one 0.08%</span>
                <span>
                  {
                    +(
                      (booking?.flight?.price + booking?.serviceCharge) *
                      0.0008
                    ).toFixed(2)
                  }{" "}
                  {currencyType(currency)}
                </span>
              </div>
              <hr />
              <div className="flex justify-between items-center">
                <div className="">
                  <p>Payment amount on due date.</p>
                  <p className="w-3/4 text-xs text-green-500">
                    if you pay before due date payment amount will decrease
                  </p>
                </div>
                <span>
                  {convertNumbThousand(
                    booking?.totalPrice +
                      +(
                        (booking?.flight?.price + booking?.serviceCharge) *
                        0.0008
                      ).toFixed(2) *
                        (company?.creditType === ONE_WEEK_CREDIT
                          ? 7 - (diffDate + 1)
                          : 14 - (diffDate + 1))
                  )}{" "}
                </span>
              </div>
            </div>
          )}

          <div className="border-b border-neutral-200"></div>
          <div className="flex justify-between text-xl font-bold text-black">
            <span>Total Price</span>
            <span>
              {/* {convertToNumber(
                airReservation.AirPricingInfo._attributes.TotalPrice
              )}{" "} */}
              {totalPrice()} {airPrice._attributes.TotalPrice.substring(0, 3)}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderMain = () => {
    return (
      <div className="flex flex-col px-5 space-y-8 w-full shadow sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 sm:p-6 xl:p-8">
        <h2 className="text-3xl font-semibold lg:text-4xl">
          Confirm and payment
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <div>
            <h3 className="text-2xl font-semibold">Traveler Information</h3>
            <NcModal
              renderTrigger={(openModal) => (
                <span
                  onClick={() => openModal()}
                  className="block mt-1 underline cursor-pointer lg:hidden"
                >
                  View booking details
                </span>
              )}
              renderContent={renderSidebar}
              modalTitle="Booking details"
            />
          </div>
          <div className="flex flex-col mt-6 w-full rounded-3xl border divide-y shadow border-neutral-200 dark:border-neutral-700 sm:flex-row sm:divide-x sm:divide-y-0 divide-neutral-200">
            <div className="px-1 py-4 text-lg font-light md:mx-32 md:px-5">
              {travelers instanceof Array ? (
                travelers.map((travel, index) => (
                  <>
                    <h1 className="p-2 text-xl font-bold">
                      Passenger {++index}
                    </h1>
                    <div className="flex flex-row justify-between px-4 space-x-12">
                      <h1 className="">Name</h1>
                      <span className="text-neutral-500 dark:text-neutral-400">
                        {travel?.BookingTravelerName?._attributes?.First}{" "}
                        {travel?.BookingTravelerName?._attributes?.Last}
                      </span>
                      {/* </div> */}
                    </div>
                    <div className="flex flex-row justify-between px-4 py-2 space-x-6">
                      <h1 className="">Email</h1>
                      <h1 className="text-neutral-500 dark:text-neutral-400">
                        {travel?.Email?._attributes?.EmailID}{" "}
                      </h1>
                    </div>

                    <div className="flex flex-row justify-between px-4 py-2">
                      <h1 className="">PNR</h1>
                      <span className="text-neutral-500 dark:text-neutral-400">
                        {airReservation._attributes.LocatorCode}
                      </span>
                    </div>
                    <div className="flex flex-row justify-between px-4 py-2">
                      <h1 className="">Seat</h1>
                      <span className="text-neutral-500 dark:text-neutral-400">
                        {/* {travel?.AirSeatAssignment?._attributes?.Seat ||
                          "Seat Not Selected"} */}

                        {travel?.AirSeatAssignment ? (
                          travel?.AirSeatAssignment instanceof Array ? (
                            travel?.AirSeatAssignment?.map((seat, index) => (
                              <span key={index}>{seat._attributes.Seat} </span>
                            ))
                          ) : (
                            <span>
                              {travel?.AirSeatAssignment?._attributes?.Seat}
                            </span>
                          )
                        ) : (
                          <span>Seat Not Selected</span>
                        )}
                      </span>
                    </div>
                    <div className="flex flex-row justify-between items-center px-4 py-2 space-x-6">
                      {/* <div className="justify-between"> */}
                      <h1 className="">SSR</h1>
                      <button
                        onClick={() => {
                          setShowSSR(!showSSR);
                        }}
                        type="button"
                      >
                        <i
                          className={
                            "text-2xl text-main font-black " +
                            (showSSR
                              ? "fa fa-chevron-down"
                              : "fa fa-chevron-up")
                          }
                        ></i>
                      </button>
                    </div>
                    <div
                      // className="flex flex-col gap-2 justify-between text-black"
                      className={
                        showSSR
                          ? "hidden p-2 rounded-md row border-1 border-slate-200"
                          : "flex visible flex-col gap-2 justify-between text-black"
                      }
                    >
                      {travel?.SSR?.length > 0
                        ? travel?.SSR?.map((ssr, index) => (
                            <div
                              key={index}
                              className="flex flex-row gap-5 justify-center px-2 py-1 mx-3 rounded-xl border-1 border-slate-200"
                            >
                              <h1 className="px-2">
                                {SSRTypes(ssr?._attributes?.Type)} (
                                {ssr._attributes.Type})
                              </h1>
                              <h1 className="px-2 text-gray-500">
                                {SSRStatus(ssr._attributes.Status)} (
                                {ssr._attributes.Status})
                              </h1>
                            </div>
                          ))
                        : travel?.SSR?._attributes && (
                            <div className="flex flex-row gap-5 justify-center px-2 py-1 mx-3 rounded-xl border-1 border-slate-200">
                              <h1 className="px-2">
                                {SSRTypes(travel?.SSR?._attributes?.Type)} (
                                {travel?.SSR?._attributes?.Type})
                              </h1>
                              <h1 className="px-2 text-gray-500">
                                {SSRStatus(travel?.SSR?._attributes?.Status)} (
                                {travel?.SSR?._attributes?.Status})
                              </h1>
                            </div>
                          )}
                    </div>
                  </>
                ))
              ) : (
                <>
                  <div className="flex flex-row justify-between px-4 space-x-12">
                    {/* <div className="space-x-20"> */}
                    <h1 className="">Name</h1>
                    <span className="text-neutral-500 dark:text-neutral-400">
                      {travelers?.BookingTravelerName?._attributes?.First}{" "}
                      {travelers?.BookingTravelerName?._attributes?.Last}
                    </span>
                    {/* </div> */}
                  </div>
                  <div className="flex flex-row justify-between px-4 py-2 space-x-6">
                    {/* <div className="justify-between"> */}
                    <h1 className="">Email</h1>
                    <h1 className="text-neutral-500 dark:text-neutral-400">
                      {travelers?.Email?._attributes?.EmailID}{" "}
                    </h1>
                  </div>

                  {/* <div className="flex flex-row justify-between px-4 py-2">
                    <h1 className="">Flight</h1>
                    <span className="text-neutral-500 dark:text-neutral-400">
                      {
                        airReservation.AirSegment.FlightDetails._attributes
                          .Origin
                      }{" "}
                      -{" "}
                      {
                        airReservation.AirSegment.FlightDetails._attributes
                          .Destination
                      }
                    </span>
                  </div> */}

                  {/* <div className="flex flex-row justify-between px-4 py-2">
                <h1 className="">Departure Date</h1>
                <span className="text-neutral-500 dark:text-neutral-400">
                  {moment(
                    airReservation.AirSegment._attributes.DepartureTime
                  ).format("DD MMM YYYY hh:mm A")}
                </span>
              </div> */}
                  {/* <div className="flex flex-row justify-between px-4 py-2 space-x-20">
                <h1 className="">Arrival Date</h1>
                <span className="text-neutral-500 dark:text-neutral-400">
                  {moment(
                    airReservation.AirSegment._attributes.ArrivalTime
                  ).format("DD MMM YYYY hh:mm A")}
                </span>
              </div> */}
                  {/* <div className="flex flex-row justify-between px-4 py-2">
                <h1 className="">Flight Number</h1>
                <span className="text-neutral-500 dark:text-neutral-400">
                  {airReservation.AirSegment._attributes.FlightNumber}
                </span>
              </div> */}
                  <div className="flex flex-row justify-between px-4 py-2">
                    <h1 className="">PNR</h1>
                    <span className="text-neutral-500 dark:text-neutral-400">
                      {airReservation._attributes.LocatorCode}
                    </span>
                  </div>
                  <div className="flex flex-row justify-between px-4 py-2">
                    <h1 className="">Seat</h1>
                    <span className="text-neutral-500 dark:text-neutral-400">
                      {/* {travelers?.AirSeatAssignment?._attributes?.Seat ||
                        "Seat Not Selected"} */}
                      {travelers?.AirSeatAssignment ? (
                        travelers?.AirSeatAssignment instanceof Array ? (
                          travelers?.AirSeatAssignment?.map((seat, index) => (
                            <span key={index}>{seat._attributes.Seat} </span>
                          ))
                        ) : (
                          <span>
                            {travelers?.AirSeatAssignment?._attributes?.Seat}
                          </span>
                        )
                      ) : (
                        <span>Seat Not Selected</span>
                      )}
                    </span>
                  </div>
                  <div className="flex flex-row justify-between items-center px-4 py-2 space-x-6">
                    {/* <div className="justify-between"> */}
                    <h1 className="">SSR</h1>
                    <button
                      onClick={() => {
                        setShowSSR(!showSSR);
                      }}
                      type="button"
                    >
                      <i
                        className={
                          "text-2xl text-main font-black " +
                          (showSSR ? "fa fa-chevron-down" : "fa fa-chevron-up")
                        }
                      ></i>
                    </button>
                  </div>
                  <div
                    // className="flex flex-col gap-2 justify-between text-black"
                    className={
                      showSSR
                        ? "hidden p-2 rounded-md row border-1 border-slate-200"
                        : "flex visible flex-col gap-2 justify-between text-black"
                    }
                  >
                    {travelers?.SSR?.length > 0
                      ? travelers?.SSR?.map((ssr, index) => (
                          <div
                            key={index}
                            className="flex flex-row gap-5 justify-center px-2 py-1 mx-3 rounded-xl border-1 border-slate-200"
                          >
                            <h1 className="px-2">
                              {SSRTypes(ssr._attributes.Type)} (
                              {ssr._attributes.Type})
                            </h1>
                            <h1 className="px-2 text-gray-500">
                              {SSRStatus(ssr._attributes.Status)} (
                              {ssr._attributes.Status})
                            </h1>
                          </div>
                        ))
                      : travelers?.SSR?._attributes && (
                          <div className="flex flex-row gap-5 justify-center px-2 py-1 mx-3 rounded-xl border-1 border-slate-200">
                            <h1 className="px-2">
                              {SSRTypes(travelers?.SSR?._attributes?.Type)} (
                              {travelers?.SSR?._attributes?.Type})
                            </h1>
                            <h1 className="px-2 text-gray-500">
                              {SSRStatus(travelers?.SSR?._attributes?.Status)} (
                              {travelers?.SSR?._attributes?.Status})
                            </h1>
                          </div>
                        )}
                  </div>
                </>
              )}
            </div>

            {/* <ModalSelectGuests
              defaultValue={guests}
              onChangeGuests={setGuests}
              renderChildren={({ openModal }) => (
                <button
                  type="button"
                  onClick={openModal}
                  className="flex flex-1 justify-between p-5 space-x-5 text-left"
                >
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">Guests</span>
                    <span className="mt-1.5 text-lg font-semibold">
                      <span className="line-clamp-1">
                        {`${guests.guestAdults || 0} Guests`}
                      </span>
                    </span>
                  </div>
                  <PencilAltIcon className="w-6 h-6 text-neutral-6000 dark:text-neutral-400" />
                </button>
              )}
            /> */}
          </div>
        </div>

        <div>
          {!payment?.paymentInstructions && (
            <PaymentMethodsList
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              setShowCorporateList={setShowCorporateList}
              user={user}
              enterprise={enterprise}
              company={company}
              totalPrice={priceToNumber(totalPrice())}
              setSelectedCorporate={setSelectedCorporate}
              departureDate={departureTime}
              passengerTypeState={passengerTypeState}
              currency={currency}
              diffDate={diffDate}
              isBefore24Hours={isBefore24Hours}
            />
          )}
          {/* {paymentMethod !== "wallet" &&
            paymentMethod !== "credit" &&
            paymentMethod !== "kacha" && */}
          {!DIRECT_PAYMENT.includes(paymentMethod) && payment && (
            <div className="p-5 rounded-xl border border-black shadow">
              <h1 className="text-2xl text-center capitalize font bold">
                {paymentMethod}
              </h1>
              <div className="flex flex-wrap justify-between px-2">
                <h1 className="text-xl font-semibold">Your PNR code is:</h1>
                <button
                  className="px-2 py-1 text-white rounded-lg cursor-pointer bg-slate-300"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      // airReservation._attributes.LocatorCode
                      payment.paymentReference
                    );
                    toast.success("Payment Reference code copied to clipboard");
                  }}
                >
                  <h1 className="flex text-xl font-bold">
                    {payment.paymentReference}
                    {/* {airReservation._attributes.LocatorCode} */}
                    <button className="mx-2 hover:text-green-800 hover:rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
                        />
                      </svg>
                    </button>
                  </h1>
                </button>
              </div>
              {renderInstructions()}
            </div>
          )}
        </div>

        <h1 className="text-xl font-semibold">
          Selected Payment Method:{" "}
          <span className="text-main">
            {
              paymentMethods.find((method) => method.name === paymentMethod)
                ?.title
            }
          </span>
        </h1>

        {paymentMethod === "wallet" ||
        paymentMethod === "credit" ||
        paymentMethod === "USDCredit" ? (
          <>
            <div className="space-y-2 lg:hidden row lg:p-0">
              <div className="col-12">
                <ButtonPrimary className="py-3 w-full bg-red-500 hover:bg-red-400">
                  Cancel Booking
                </ButtonPrimary>
              </div>
              <div className="col-12">
                <ButtonPrimary
                  className="w-full text-white bg-gray-400 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleWithoutPayment}
                  disabled={isBefore24Hours}
                >
                  Continue Without Payment
                </ButtonPrimary>
              </div>
              <div className="col-12">
                <ButtonPrimary
                  onClick={() => handleClick()}
                  className="mb-3 w-full"
                >
                  Confirm and pay
                </ButtonPrimary>
              </div>
            </div>

            <div className="hidden gap-4 justify-between pt-8 lg:flex">
              {/* <div className="w-full">
                <ButtonPrimary className="py-3 w-44 bg-red-500 hover:bg-red-400">
                  Cancel Booking
                </ButtonPrimary>
              </div> */}
              <div className="w-full">
                <ButtonPrimary
                  className="w-full text-black rounded-3xl border-gray-500 bg-slate-50 border-1 hover:text-white hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleWithoutPayment}
                  disabled={isBefore24Hours}
                >
                  {/* Continue Without Payment */}
                  Pay Later
                </ButtonPrimary>
              </div>
              <div className="w-full">
                <ButtonPrimary
                  onClick={() => handleClick()}
                  className="w-full text-black rounded-3xl border-1 border-main bg-slate-50 hover:text-white hover:bg-main-900 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50"
                >
                  Confirm and pay
                </ButtonPrimary>
              </div>
            </div>
          </>
        ) : paymentMethod === "" ? (
          <div className="space-y-3 row lg:p-0">
            <div className="col-12">
              <ButtonPrimary
                className="w-full text-white bg-gray-400 hover:bg-gray-300"
                // onclick go home
                onClick={() => navigate("/")}
              >
                No Payment Method Selected
              </ButtonPrimary>
            </div>
          </div>
        ) : (
          <div className="space-y-3 row lg:p-0">
            <div className="col-12">
              <ButtonPrimary
                className="py-3 w-full bg-green-500 hover:bg-green-400"
                onClick={initiatePayment}
                // onClick={handleWithoutPayment}
              >
                Proceed
              </ButtonPrimary>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={`px-1 py-4 nc-CheckOutPage ${className}`}
      data-nc-id="CheckOutPage"
    >
      <main className="flex flex-col-reverse mt-11 mb-24 lg:mx-24 lg:mb-32 lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10">{renderMain()}</div>
        <div className="flex-grow mb-10 lg:block">{renderSidebar()}</div>
      </main>
      {paymentMethod === "credit" && (
        <CorporateList
          show={showCorporateList}
          handleClose={handleCorporateSubmit}
        />
      )}
      {paymentMethod === "kacha" && (
        <KachaCreditOTP handleSubmit={handleKachaSubmit} booking={booking} />
      )}
    </div>
  );
};

export default CheckOutPage;
